import React from 'react';
import { motion } from 'framer-motion';
import './Gallery.css';

const Gallery = () => {
  const galleryItems = [
    {
      title: 'Morning Yoga',
      img: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Meditation',
      img: 'https://images.unsplash.com/photo-1508672019048-805c876b67e2?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Outdoor Session',
      img: 'https://images.unsplash.com/photo-1600618528240-fb9fc964b853?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Healthy Lifestyle',
      img: 'https://images.unsplash.com/photo-1512438248247-f0f2a5a8b7f0?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Group Practice',
      img: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Mindfulness',
      img: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Yoga Retreat',
      img: 'https://images.unsplash.com/photo-1524863479829-916d8e77f114?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Inner Peace',
      img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=600'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="gallery">
      <div className="gallery-container">
        
        <motion.div 
          className="gallery-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="gallery-subtitle">OUR GALLERY</h4>
          <h2 className="gallery-title">Moments of Wellness & Peace</h2>
          <p className="gallery-desc">
            Take a glimpse into our yoga sessions, workshops, and mindful community.
          </p>
          <div className="gallery-divider"></div>
        </motion.div>

        <motion.div 
          className="gallery-masonry"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {galleryItems.map((item, idx) => (
            <motion.div key={idx} className="gallery-item" variants={itemVariants}>
              <img src={item.img} alt={item.title} className="gallery-img" />
              <div className="gallery-overlay">
                <div className="gallery-info">
                  <h3 className="gallery-item-title">{item.title}</h3>
                  <div className="gallery-view-btn">
                    <span>View Image</span>
                    <span className="arrow">→</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;
